import type {RichTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'

type DrawerTextProps = {
  text?: RichTextField
}

export const DrawerText = ({text}: DrawerTextProps) => {
  if (!isFilled.richText(text)) {
    return null
  }

  return (
    <PrismicRichText
      components={{
        paragraph: ({children}) => <p className="text-[20px] font-normal leading-[1.35] text-moss-black">{children}</p>,
      }}
      field={text}
    />
  )
}
